function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\u0437\u0430\u0433\u043B\u0443\u0448\u043A\u0430 / \u0430\u0440\u0442\u0438\u0441\u0442");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u043F\\u0440\\u043E\\u0433\\u0440\\u0430\\u043C\\u043C\\u0430-/-\\u0440\\u0435\\u043A\\u043E\\u043C\\u0435\\u043D\\u0434\\u0430\\u0446\\u0438\\u0438",
  transform: "translate(-27.000000, -490.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u0437\\u0430\\u0433\\u043B\\u0443\\u0448\\u043A\\u0430-/-\\u0430\\u0440\\u0442\\u0438\\u0441\\u0442",
  transform: "translate(27.000000, 490.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-6",
  fill: "#000000",
  cx: 28.8,
  cy: 28.8,
  r: 28.8
}), /*#__PURE__*/React.createElement("g", {
  id: "karaoke-microphone",
  transform: "translate(21.000000, 21.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.6814222,1.31693333 C13.8321778,0.467688889 12.7030222,0 11.5020444,0 C10.3010222,0 9.17191111,0.467688889 8.32266667,1.31693333 C6.5696,3.07004444 6.5696,5.92253333 8.32266667,7.67568889 C9.17191111,8.52488889 10.3010222,8.99262222 11.5020444,8.99262222 C12.7030222,8.99262222 13.8321778,8.52493333 14.6814222,7.67568889 C16.4344889,5.92253333 16.4344889,3.07004444 14.6814222,1.31693333 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.24635556,9.33497778 C9.23751111,9.33137778 8.35595556,8.96795556 7.6932,8.30515556 C7.0328,7.6448 6.66693333,6.76071111 6.66337778,6.752 C6.54302222,6.45635556 6.31284444,6.27982222 6.04764444,6.27982222 C5.85368889,6.27982222 5.66066667,6.37657778 5.50413333,6.55226667 L0.255511111,12.4427111 C-0.0986222222,12.8401333 -0.0804888889,13.4696889 0.295911111,13.8460444 L0.689822222,14.24 L0.249822222,14.68 C-0.0447555556,14.9745778 -0.0447555556,15.4539556 0.249822222,15.7485333 C0.392533333,15.8912444 0.582266667,15.9698222 0.784088889,15.9698222 C0.985911111,15.9698222 1.17564444,15.8912 1.31835556,15.7485333 L1.75831111,15.3085778 L2.15222222,15.7025333 C2.33977778,15.8900444 2.60368889,15.9976444 2.87635556,15.9976444 C2.87635556,15.9976444 2.87635556,15.9976444 2.87635556,15.9976444 C3.12995556,15.9976444 3.3712,15.9071556 3.55551111,15.7429333 L9.44608889,10.4942222 C9.65253333,10.3103111 9.74875556,10.0761778 9.71008889,9.85191111 C9.67146667,9.62764444 9.5024,9.4392 9.24635556,9.33497778 Z M6.35808889,11.0574667 L5.8492,11.5663556 C5.54493333,11.8705778 5.14973333,12.0522222 4.79208889,12.0522222 C4.5476,12.0522222 4.33675556,11.9705778 4.18226667,11.8160889 C3.78493333,11.4187556 3.89462222,10.6865333 4.432,10.1491111 L4.94088889,9.64022222 C5.24515556,9.336 5.64035556,9.15435556 5.99804444,9.15435556 C6.24253333,9.15435556 6.45337778,9.236 6.60786667,9.39048889 C7.0052,9.78782222 6.89546667,10.5200444 6.35808889,11.0574667 Z",
  id: "Shape"
}))))));

var SvgMicro = function SvgMicro(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/micro.e201a86a.svg";
export { ForwardRef as ReactComponent };